////////////////////////////////////////////
//
// Tabs
//
////////////////////////////////////////////

import { Foundation } from 'foundation-sites/js/foundation.core';
import { Dropdown } from 'foundation-sites/js/foundation.dropdown';
// import { Tabs } from 'foundation-sites/js/foundation.tabs';

$(function() {

  var tabsClass = '.js-tabs';
  var tabsDropdownClass = '.js-tabs-dropdown';

  var tabOptions = {
    'linkClass': 'tabs__title',
    'linkActiveClass': 'is-active',
    'panelClass': 'tabs-content__panel',
  }

  var dropdownOptions = {
    'vOffset': -1,
    'position': 'bottom',
    'alignment': 'center',
    'closeOnClick': true,
    'autoFocus': true
  }

  if ($('.js-tabs').length > 0) {

    // TODO: Had to disable the tabs function because it doesn't work
    // when there a real URL on the tab link instead of a hash link (e.g. #section).
    // For now, Vue is taking care of the couple places where this component is needed.

    // $(tabsDropdownClass).each(function(index) {
    //   var tabs = new Foundation.Tabs($(this), tabOptions);
    // })

    $(tabsDropdownClass).each(function(index) {
      var tabsDropdown = new Foundation.Dropdown($(this), dropdownOptions);
    })

    // When tabs are changed, change the text of the dropdown trigger

    // $(tabsClass).on('change.zf.tabs', function(event) {
    //   var $tabs = $(event.target).closest('.tabs');
    //   var activeTabText = $tabs.find('.' + tabOptions.linkActiveClass).text();
    //   var $dropdown = $tabs.find('.tabs__dropdown');
    //   var $dropdownPane = $tabs.find('.tabs__dropdown-pane');
    //
    //   $dropdown.text(activeTabText);
    // });

    // Close the dropdown when clicked, but not when changing with keyboard

    $(tabsDropdownClass + ' a').on('click', function(event) {
      $(tabsDropdownClass).foundation('close');
    })

  }
});
